import SwivuSettingsTagValueTabBase from "./SwivuSettingsTagValueTabBase.jsx";
import { TAGS_KEYS } from "../../../other/constants/TagsKeys.jsx";
import { STORE_KEYS } from "../../../other/constants/StoreKeys.jsx";
import {GRANTS} from "../../../other/constants/PrivilegeTypes.jsx";
import {SETTING_TAB_WIDGET_KEYS} from "../../../other/constants/OtherKeys.jsx";

const GRID_KEYS = {
  tagsGrid: "clientTagsGrid",
};

export default class SwivuSettingsClientTagsTab extends SwivuSettingsTagValueTabBase {
  static get $name() {
    return "SwivuSettingsClientTagsTab";
  }

  static get type() {
    return "swivusettingsclienttagstab";
  }

  get swivuDeepLinkSlug() {
    return SETTING_TAB_WIDGET_KEYS.clientTagsTab;
  }

  getStoreName() {
    return STORE_KEYS.clientTagValuesStore;
  }

  getTagKeysWithWidgetRef() {
    return {
      [TAGS_KEYS.tag]: GRID_KEYS.tagsGrid,
    };
  }

  swivuCheckGrants(user) {
    if (!user.can(GRANTS.grant_one)) {
      const grid = this.widgetMap[GRID_KEYS.tagsGrid];
      grid.disabled = true;
      grid.readOnly = true; // readonly will prevent row reorder
      grid.bbar.items.forEach(
        (item) => (item.disabled = true)
      );
    }
  }

  static get configurable() {
    return {
      title: "Clients",
      ...SwivuSettingsTagValueTabBase.getDefaultLayoutSettings(),
      items: {
        [GRID_KEYS.tagsGrid]: SwivuSettingsTagValueTabBase.getGridWidget({
          headerText: "Client Tags",
          defaultValue: "Enter Tag"
        }),
      }
    };
  }
}

SwivuSettingsClientTagsTab.initClass();
